<template>
  <div>

    <!-- Add Visit Notes -->
    <!-- <b-modal
      :id="'visitNotes' + dailyLogData.visit_id"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      :ref="'visitNotes' + dailyLogData.visit_id"
    >
      <slot name="modal-header">
        <div
          class="modal-header flex-row"
          style="padding-inline-start: 0; padding-top: 0"
        >
          <h4 class="modal-title">
            <slot name="modal-title"> Visit Notes </slot>
          </h4>
        </div>
      </slot>
      <div class="d-block text-center mb-4" style="padding-inline-start: 0">
        <b-form-textarea
          id="myTextarea"
          :value="visitNotesCopy"
          @keyup="visitNotesChanged($event)"
          class="form-control visitNotesText"
          rows="5"
          placeholder="Notes"
          maxlength="255"
        ></b-form-textarea>
      </div>
      <div class="visit-note-action-btns">
        <b-button
          variant="primary"
          type="button"
          pill
          :disabled="isDisabled"
          class="save-visit-note"
          @click="addVisitNotes"
        >
          <span>Save</span>
        </b-button>

        <b-button
          variant="outline-danger"
          type="button"
          pill
          class="cancel-visit-note"
          @click="$bvModal.hide('visitNotes' + dailyLogData.visit_id)"
        >
          <span>Cancel</span>
        </b-button>
      </div>
    </b-modal> -->

    <!-- add visit notes modal -->
    <b-modal
      :id="'add_visit_notes_modal' + dailyLogData.visit_id"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      :ref="'add_visit_notes_modal' + dailyLogData.visit_id"
    >
      <addVisitNotesModal :dailyLogData="dailyLogData" :modalIdType="'stringWithVisitId'"/>
    </b-modal>

    <!-- Fill in Compliance & Manage Visit -->
    <b-modal
      :id="'compFillIn_modal' + dailyLogData.visit_id"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      @show="showCompModal"
      @hidden="hideCompModal"
      :ref="'compFillIn_modal' + dailyLogData.visit_id"
    >
      <div
        :class="{
          'modal-topheader-left': getApproveVisit || getRejectVisit,
          'modal-topheader': !getApproveVisit && !getRejectVisit,
        }"
      >
        <div class="modal-toptitle">
          <p
            :class="{
              'modal-title-left': getApproveVisit || getRejectVisit,
              'modal-title': !getApproveVisit && !getRejectVisit,
            }"
          >
            {{ visitModalTitle }}
          </p>

          <svg
            style="position: absolute; top: 32px; inset-inline-end: 32px"
            @click="hideModal('compFillIn_modal' + dailyLogData.visit_id)"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
              fill="#F46A6A"
            />
          </svg>
        </div>
      </div>
      <ComplianceFillIn
        :modalId="'compFillIn_modal' + dailyLogData.visit_id"
        :modalLoading="modalLoading"
        :firstName="firstName"
        :lastName="lastName"
        :id="id"
        :visitId="visitId"
        :manageVisit="manageVisit"
        :visitRejected="visitRejected"
        :visitApproved="visitApproved"
        :scan_time="scan_time"
        :action_by="action_by"
        :rejectionReason="rejectionReason"
        :userTypeId="userTypeId"
        :areaId="areaId"
        :onlineCompliance="false"
      />
    </b-modal>

    <!-- edit expected visit -->
   <b-modal
      :id="'edit_expected_visit_modal' + dailyLogData.visit_id"
      scrollable
      hide-header
      hide-footer
      size="md"
      no-close-on-esc
      :ref="'edit_delete_visit_modal' + dailyLogData.visit_id"
      @hide="resetReason"
    >
      <editExpectedVisitModal :dailyLogData="dailyLogData" :modalIdType="'stringWithVisitId'"/>
    </b-modal>

    <!-- delete expected visit -->
    <b-modal 
      :id="'delete_expected_visit_modal' + dailyLogData.visit_id"
      scrollable
      hide-header
      hide-footer
      size="md"
      no-close-on-esc
      :ref="'edit_delete_visit_modal' + dailyLogData.visit_id"
      @hide="resetReason"
    >
      <deleteExpectedVisitModal :dailyLogData="dailyLogData" :modalIdType="'stringWithVisitId'"/>
    </b-modal>

    <DxDropDownButton
      :items="items"
      :drop-down-options="{ width: 141.41, maxHeight: 179 }"
      :scrollable="true"
      :text="$t('common.grid.selectActions')"
      id="daily-select"
      class="selectActions"
      itemTemplate="actionsTemp"
      :disabled="isSelectionModeEnabled"
    >
      <template #actionsTemp="{ data }">
        <div
          :class="{
            'dashboard-actions-seperator':
              data.text !=
              items.filter((item) => item.visible)[
                items.filter((item) => item.visible).length - 1
              ].text,
          }"
          class="dropdown-wrapper"
          title=""
          @click="
            data.id == 'addVisitNotes'
              ? openVisitNotes(
                  dailyLogData.visit_id,
                  dailyLogData.originalVisitNotes
                )
              : data.id == 'editVisit' || data.id == 'deleteVisit'
              ? editDeleteVisit(dailyLogData, data.id == 'editVisit' ? 1 : 0)
              : data.id == 'fillInComp'
              ? openCompModal(dailyLogData, false)
              : ''
          "
        >
          <div
            class="dropdown-items"
            :class="{ 'red-remove': data.id == 'deleteVisit' }"
            title=""
          >
            {{ data.translatedText }}
          </div>
          <!-- <hr
            v-if="data.text != items.filter(item => item.visible)[items.filter(item => item.visible).length - 1].text"
            role="separator"
            aria-orientation="horizontal"
            class="dropdown-divider"
          /> -->
        </div>
      </template>
    </DxDropDownButton>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

import DxDropDownButton from "devextreme-vue/drop-down-button";
import ComplianceFillIn from "@/components/dashboard/complianceFillIn";
import addVisitNotesModal from "@/components/dashboard/addVisitNotes";
import editExpectedVisitModal from "@/components/dashboard/editExpectedVisit";
import deleteExpectedVisitModal from "@/components/dashboard/deleteExpectedVisit";

export default {
  components: {
    DxDropDownButton,
    ComplianceFillIn,
    addVisitNotesModal,
    editExpectedVisitModal,
    deleteExpectedVisitModal,
  },
  props: ["dailyLogData", "isSelectionModeEnabled"],
  data() {
    return {
      modalLoading: null,
      items: [],
      open: false,
      changeVisitReason: "",
      isLoading: false,
      visitModalTitle: "",
      visitData: null,
      isEditVisit: null,
      manageVisit: null,
      fullName: "",
      dateValue: null,
      timeValue: null,
      offset: null,
      daysDiff: null,
      preRegTimeZone: null,
      dateValidation: false,
      timeValidation: false,
      checkValidation: false,
      firstName: "",
      lastName: "",
      visitRejected: false,
      visitApproved: false,
      scan_time: null,
      rejectionReason: null,
      action_by: null,
      userTypeId: "",
      id: "",
      areaId: "",
      visitId: null,
      visitNotesCopy: "",
      isDisabled: false,
    };
  },

  computed: {
    ...mapGetters("preRegistration", [
      "getVisitApproved",
      "getVisitRejected",
      "getApproveVisit",
      "getRejectVisit",
    ]),

    availableHours: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      this.dateValue?.setHours(12);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        const arr = this.range(cTime, 23);
        const hrsArr = [];
        arr.map((hours) => {
          if (!hrsArr.includes(hours % 12))
            hrsArr.push(hours % 12 ? hours % 12 : 0);
        });
        return hrsArr;
      }
      return this.range(0, 23);
    },

    availableMinuts: function () {
      let todayDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let dateString = todayDate.toISOString().slice(0, 10);
      if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
        let cTime = todayDate.getHours();
        let selectedHour = this.timeValue?.getHours();
        if (cTime === selectedHour) {
          return this.range(todayDate.getMinutes() + 5, 59);
        }
      }
      return this.range(0, 59);
    },
  },

  beforeMount() {
    console.log("mount");
    this.items = [];
    // console.log("data", this.dailyLogData);

    this.items.push(
      {
        text: "Add Visit Notes",
        translatedText: this.$t("dashboard.grid.addVisitNotes"),
        id: "addVisitNotes",
        visible: true,
      },
      {
        text: "Fill in Compliance",
        translatedText: this.$t("common.fillInCompliance"),
        id: "fillInComp",
        visible:
          this.dailyLogData.scan_data_type_id != 5 &&
          this.showFillInComp(this.dailyLogData),
      },
      {
        text: "Edit Expected Visit",
        translatedText: `${this.$t("common.edit")} ${this.$t(
          "common.expectedVisit"
        )}`,
        id: "editVisit",
        visible:
          this.dailyLogData.scan_data_type_id == 6 &&
          this.dailyLogData.Data.isExpectedScanExist,
      },
      {
        text: "Delete Expected Visit",
        translatedText: `${this.$t("common.delete")} ${this.$t(
          "common.expectedVisit"
        )}`,
        id: "deleteVisit",
        visible:
          this.dailyLogData.scan_data_type_id == 6 &&
          this.dailyLogData.Data.isExpectedScanExist,
      }
    );
  },

  watch: {
    getRejectVisit(value) {
      if (value) {
        this.visitModalTitle = this.$t("common.rejectVisitRequest");
      } else {
        this.visitModalTitle = this.manageVisit
          ? this.$t("common.manageVisit")
          : this.$t("common.fillInCompliance");
      }
    },
  },

  methods: {
    ...mapActions("preRegistration", [
      "setVisitApproved",
      "setVisitRejected",
      "setApproveVisit",
      "setRejectVisit",
      "editExpectedVisit",
      "deleteExpectedVisit",
    ]),
    ...mapActions("compliance", [
      "fetchUserCompliance",
      "selectComplianceCreated",
      "setModalClosed",
    ]),
    ...mapActions("sites", ["fetchAreaDocument"]),

    hideModal(id) {
      this.$bvModal.hide(id);
    },
    resetReason() {
      this.changeVisitReason = "";
    },

    showCompModal() {
      this.setModalClosed(false);
    },

    hideCompModal() {
      this.setModalClosed(true);
    },

    showFillInComp(data) {
      const expectedVisit = data.Data.isExpectedScanExist;
      // data.scan_data_type.id == 6;
      // console.log("expectedVisit", expectedVisit, data);
      if (
        expectedVisit &&
        (data.pre_registration_method == "REGISTRATION_ALLOWED" ||
          data.pre_registration_method == "PRE_REGISTERED_ONLY")
      ) {
        if (
          data.Data.expectedJourneyStageId == "compliance_pending" ||
          data.Data.expectedJourneyStageId == "compliance_failed" ||
          (data.Data.expectedJourneyStageId == "ready_to_sign_in" &&
            // data.scans.find(
            //   (item) =>
            //     item.scan_data_type.id == 13 || // compliance filled in status(13)
            //     (expectedVisit.metadata &&
            //       expectedVisit.metadata.checks &&
            //       expectedVisit.metadata.checks.length > 0) // all compliance is optional
            // ))
            data.Data.complianceFilledInMetadata &&
            data.Data.complianceFilledInMetadata.checks &&
            data.Data.complianceFilledInMetadata.checks.length > 0)
        )
          return true;
      }
      return false;
    },

    openCompModal(data, manageVisit) {
      this.modalLoading = true;
      this.$bvModal.show("compFillIn_modal" + data.visit_id);
      this.$emit("onSetVisitData", this.dailyLogData);
      this.setVisitApproved(null);
      this.setVisitRejected(null);
      this.setApproveVisit(false);
      this.setRejectVisit(false);
      this.selectComplianceCreated(null);
      this.visitRejected = false;
      this.visitApproved = false;
      this.visitModalTitle = manageVisit
        ? this.$t("common.manageVisit")
        : this.$t("common.fillInCompliance");
      this.manageVisit = manageVisit;
      this.visitData = data;
      // console.log("data", data);
      this.firstName = data.FirstName;
      this.lastName = data.LastName;
      this.id = data.user_id;
      this.visitId = data.visit_id;
      this.userTypeId = data.user_type_id;
      this.areaId = data.area_id;
      const rejectedVisit = data.Data.isRejectedScanByAdmin;

      const approvedVisit = data.Data.isApprovedScanExist;

      const expectedVisit = data.Data.isExpectedScanExist;

      if (
        data.pre_registration_method ==
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
      ) {
        if (rejectedVisit) {
          this.visitRejected = true;
          this.action_by = data.Data.RejectedScanFullName;
          this.scan_time = data.Data.RejectedScanTime;
          this.rejectionReason = data.Data.RejectedScanNotes;
        } else if (
          expectedVisit &&
          approvedVisit &&
          data.Data.expectedJourneyStageId == "ready_to_sign_in"
        ) {
          // Approved Visit
          this.visitApproved = true;
          this.action_by = data.Data.ApprovedScanFullName;
          this.scan_time = data.Data.ApprovedScanTime;
        }
      }
      this.fetchUserCompliance({
        user_id: data.user_id,
        user_type_id: data.user_type_id,
        area_id: data.area_id,
        visit_id: data.visit_id,
        entity_id: data.entity_id,
      }).then(() => {
        setTimeout(() => {
          setTimeout(() => {
            this.modalLoading = false;
            this.fetchAreaDocument({
              area_id: data.area_id,
              user_id: data.user_id,
            });
          }, 200);
        }, 500);
      });
    },

    openVisitNotes(visit_id, visitNotes) {
      this.visitNotes = this.visitNotesCopy =
        visitNotes !== "-" ? visitNotes : "";
      if (!this.visitNotes) this.isDisabled = true;
      this.visit_id = visit_id;
      this.$bvModal.show("add_visit_notes_modal" + visit_id);
    },
    visitNotesChanged(e) {
      // console.log('visitNotesChanged', e.target.value);
      this.visitNotes = e.target.value;
      if (!e.target.value) this.isDisabled = true;
      else this.isDisabled = false;
    },

    editVisitNotesChanged() {
      // console.log('visitNotesChanged', e.target.value);
      this.handleTimeChange();
    },

    addVisitNotes() {
      // console.log(this.visit_id, this.visitNotes, this.visitNotesCopy);
      if (!this.visitNotes) return;
      this.$store.dispatch("dailyLogbook/addVisitNotes", {
        visit_id: this.visit_id,
        notes: this.visitNotes,
      });
      this.$bvModal.hide("visitNotes" + this.visit_id);
    },

    async editDeleteVisit(data, isEdit) {
      // data.isEdit = isEdit;
      console.log("edit visit", data, isEdit);
      // this.visitData = data;
      // const expectedVisit =
      //   data.Data.isExpectedScanExist || data.Data.isNoShowScanExist;
      this.isEditVisit = isEdit;
      // if (isEdit) this.checkValidation = false;
      // this.fullName = data.FullName;
      // this.preRegTimeZone = data.site_timezone;

      // let utcDate = new Date(
      //   new Date().toLocaleString("en-US", { timeZone: "UTC" })
      // );
      // let tzDate = new Date(
      //   new Date().toLocaleString("en-US", {
      //     timeZone: this.preRegTimeZone,
      //   })
      // );
      // this.offset = utcDate.getTime() - tzDate.getTime();

      // this.dateValue = new Date(
      //   moment
      //     .utc(expectedVisit.scan_time)
      //     .tz(data.site_timezone)
      //     .format("YYYY-MM-DD HH:mm:ss")
      // );

      // this.timeValue = new Date(
      //   moment
      //     .utc(expectedVisit.scan_time)
      //     .tz(data.site_timezone)
      //     .format("YYYY-MM-DD HH:mm:ss")
      // );

      //   console.log("date0", this.dateValue, this.timeValue);
      setTimeout(async () => {
        if(isEdit) await this.$bvModal.show("edit_expected_visit_modal"+ data.visit_id);
        else await this.$bvModal.show("delete_expected_visit_modal"+ data.visit_id);
      }, 500);
    },

    editVisit() {
      if (this.isEditVisit) {
        let todayDate = new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        );
        let selectedDateTime = this.dateValue;
        selectedDateTime?.setHours(
          this.timeValue?.getHours(),
          this.timeValue?.getMinutes(),
          this.timeValue?.getSeconds()
        );

        // date validations
        if (
          (!this.dateValue && this.timeValue) ||
          (this.dateValue &&
            moment(new Date(this.dateValue)).format("YYYY-MM-DD") <
              moment(todayDate).format("YYYY-MM-DD"))
        ) {
          // this.checkValidation = false;
          this.dateValidation = true;
        }

        // time validation
        if (this.dateValue && !this.timeValue) {
          // this.checkValidation = false;
          this.timeValidation = true;
        }
        // let dateString = todayDate.toISOString().slice(0, 10);
        if (
          moment(new Date(this.dateValue)).format("YYYY-MM-DD") <=
          moment(todayDate).format("YYYY-MM-DD")
        ) {
          let cHours = todayDate.getHours();
          let cMinutes = todayDate.getMinutes() + 5;
          if (cHours === this.timeValue?.getHours()) {
            if (this.timeValue?.getMinutes() < cMinutes) {
              // this.checkValidation = false;
              this.timeValidation = true;
            }
          } else if (this.timeValue?.getHours() < cHours) {
            // this.checkValidation = false;
            this.timeValidation = true;
          }
        }

        if (this.dateValidation || this.timeValidation) return;

        // console.log(
        //   moment.utc(new Date(this.dateValue)).format("YYYY-MM-DD"),
        //   moment.utc(this.timeValue).format("HH:mm:ss")
        // );

        const selectedDateStamp = Date.parse(
          moment(this.dateValue).format("YYYY-MM-DD")
        );
        let selectedDate;
        if (this.daysDiff != 0)
          selectedDate = new Date(
            selectedDateStamp - this.daysDiff * 24 * 60 * 60 * 1000
          );
        const finalDate = this.daysDiff != 0 ? selectedDate : this.dateValue;
        const utcTime = new Date(this.timeValue);
        utcTime.setTime(this.timeValue.getTime() + this.offset);
        const finalTime = utcTime;

        // console.log("final", finalDate, finalTime);
        this.isLoading = true;
        this.editExpectedVisit({
          visit_id: this.visitData.visit_id,
          entity_id: this.visitData.entity_id,
          visit_date: moment(finalDate).format("YYYY-MM-DD"),
          visit_time: moment(finalTime).format("HH:mm:ss"),
          notes: this.changeVisitReason,
        })
          .then(() => {
            this.$bvModal.hide(
              "edit_delete_visit_modal" + this.visitData.visit_id
            );
            this.isLoading = false;
            this.changeVisitReason = "";
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.isLoading = true;
        this.deleteExpectedVisit({
          visit_id: this.visitData.visit_id,
          entity_id: this.visitData.entity_id,
          notes: this.changeVisitReason,
        })
          .then(() => {
            this.$bvModal.hide(
              "edit_delete_visit_modal" + this.visitData.visit_id
            );
            this.isLoading = false;
            this.changeVisitReason = "";
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    range(start, end) {
      return Array.from({ length: end - start + 1 }, (_, i) => i + start);
    },

    handleTimeChange() {
      this.timeValidation = false;
      this.dateValidation = false;
      const { dateValue, timeValue, changeVisitReason } = this;
      if (dateValue && timeValue && changeVisitReason) {
        this.checkValidation = true;
      } else {
        this.checkValidation = false;
      }

      const utcTime = new Date(this.timeValue);
      utcTime.setTime(this.timeValue.getTime() + this.offset); // today date utc
      const dateDiff =
        Date.parse(moment(new Date(this.timeValue)).format("YYYY-MM-DD")) -
        Date.parse(moment(utcTime).format("YYYY-MM-DD"));
      this.daysDiff = dateDiff / (60 * 60 * 24 * 1000);
    },

    disableDateBeforeCurrent(date) {
      let cDate = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: this.preRegTimeZone,
        })
      );
      let currentYear = cDate.getFullYear();
      let currentMonth = cDate.getMonth();
      let currentDay = cDate.getDate();
      return date < new Date(currentYear, currentMonth, currentDay);
    },
    disableTimeBeforeCurrent(date) {
      const time = new Date(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        ).getTime() +
          5 * 60000
      );
      const after5Mins = moment(new Date(time)).format("HH:mm:ss");
      const todayDate = moment(
        new Date(
          new Date().toLocaleString("en-US", {
            timeZone: this.preRegTimeZone,
          })
        )
      ).format("YYYY-MM-DD");
      const selectedTime = moment(new Date(date)).format("HH:mm:ss");
      return (
        moment(new Date(this.dateValue)).format("YYYY-MM-DD") == todayDate &&
        selectedTime < after5Mins
      );
    },
  },
};
</script>

<style lang="scss" scoped>
button.custom-signinout {
  margin-inline-start: 16px !important;
}
.visit-note-action-btns {
  display: flex;
  justify-content: space-between;
  width: 255px;
  margin: auto;

  button {
    width: 112px;
    height: 33px;
  }
}
</style>
<style lang="scss">
.reason-textbox div {
  width: 416px;
  justify-self: center;
}
button.btn.text-center.mt-2.px-5.mr-2.save-visit-note.btn-primary.rounded-pill:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed;
}
div[id*="compFillIn_modal"] {
  min-width: 491px !important;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  div[class*="modal-content"] {
    z-index: 1001;
  }
}
.visitNotesText {
  inset-inline-start: 32.99%;
  inset-inline-end: 33.12%;
  top: 42.67%;
  bottom: 43.56%;
  background-color: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  border-radius: 4px !important;
}

.timezone-msg {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: start;
  letter-spacing: 0.25px;
  color: #939393;
  margin-top: 16px;
  margin-inline-start: 40px;
  margin-bottom: 0px !important;
}
.is-invalid {
  border: 1.5px solid #f46a6a;
  border-radius: 4px;
}
.date-time-lable {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #787878;
  text-align: start;
  margin-bottom: 31px;
  padding-inline-start: 53px;
}
.date-piker-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.time-error {
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.25px;
  text-align: center;
  color: #f46a6a;
  margin-top: 20px;
}
.date-p {
  margin-inline-end: 15px;
}
.date-time-wrappers {
  width: 200px !important;
  height: 55px !important;

  .selected-date-lable {
    margin-bottom: -3px;
    text-align: start;
    background-color: #f2f2f2;
    padding-top: 8px;
    padding-inline-start: 12px;
    font-size: 10px;
    font-weight: 700;
    color: #103f5e;
  }
  .invaled-top-half {
    border: 1.5px solid #f46a6a;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
  }
}
.visit-permissions .strong-txt {
  color: #939393;
  font-weight: 700;
  font-size: 16px;
  line-height: 30.1px;
}
.dashboard-actions-seperator {
  border-bottom: 1px solid #e0e0e0 !important;
}
.visit-permissions {
  font-weight: 400;
  font-size: 20px;
  line-height: 38px;
  text-align: center;
  width: 380px !important;
  color: #787878;
  margin: 0px auto 8px auto;
  p {
    margin: 0px !important;
    padding: 0px !important;
  }
}
.actions-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 33px;
  button.btn.text-center.btn-primary.rounded-pill {
    width: 112px;
    height: 33px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-end: 15px;
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #ffffff;
    }
  }
  .btn-primary.disabled {
    opacity: 0.4 !important;
    cursor: not-allowed;
  }
  button.btn.text-center.btn-outline-danger.rounded-pill {
    width: 111px;
    height: 33px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: 15px;
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      :hover {
        background: #f46a6a !important;
        color: #ffffff !important;
      }
    }
  }
}
div[id*="edit_delete_visit_modal"] {
  div[id*="___BV_modal_content_"] {
    div[id*="___BV_modal_body_"] {
      padding: 0px !important;
      p.modal-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        color: #000000;
        margin-inline-start: 45px;
        text-align: start;
        margin-bottom: 44px;
        margin-top: 41px;
      }
      .form-group {
        margin-bottom: 8px !important;
      }
      .msg-con {
        width: 416px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        p.length-msg {
          font-weight: 400;
          font-size: 14px;
          margin-bottom: 0px !important;
          line-height: 22px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #939393;
        }
      }
      .normal-txt {
        font-weight: 400;
        font-size: 16px;
        line-height: 30.1px;
        text-align: center;
        margin-bottom: 36px;
        color: #787878;
      }
      p.time-error {
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 0.25px;
        margin-top: 18px;
        margin-bottom: 18px;
        color: #f46a6a;
      }
      input.mx-input::placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        margin-inline-start: 20px;
        padding-inline-start: 10px;
        color: #787878;
      }
      .actions-btns {
        margin-bottom: 21px !important;
      }
    }
  }
}

.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 12px auto !important;
    max-width: 142px !important;
    white-space: normal !important;
    padding: 1px 5px 1px 5px !important;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>
